import React, { useEffect, useState } from "react";

import { ToastError, ToastSuccess } from "src/component/uiElements/toast";
import { LOGOUT } from "src/component/helper/constants";
import {
    SelectOwner as SELECT_OWNER_INFO,
    SelectPropertyDetails as SELECT_PROPERTY_DETAILS,
    SelectFinancialDetails as SELECT_FINANCIAL_DETAILS,
    SelectMultipleFiles as SELECT_FILES,
    SelectInfraFacilities as SELECT_INFRA_FACILITIES,
} from "src/component/api/commercialProperty/CommercialPropertyAPI";


const UseCommercialPropertyInformation = (list: any) => {
    const [financialDetails, setFinancialDetails] = useState<any>(null);
    const [OwnersDetails, setOwnersDetails] = useState<any>(null);
    const [propertyDetails, setPropertyDetails] = useState<any>(null);
    const [mediaDetails, setMediaDetails] = useState<any>(null);
    const [infraFacilitiesDetails, setInfraFacilitiesDetails] = useState<any>(null);


    useEffect(() => {
        SelectOwnerInfo(list);
        SelectPropertyDetails(list);
        SelectFinancialDetails(list);
        SelectUploadedImages(list);
        SelectInfraFacilitiesDetails(list);
    }, []);


    const SelectUploadedImages = async (list: any) => {
        let inputObj = {
            UserID: list.UserID,
        };

        let request = JSON.stringify(inputObj);
        var response = await SELECT_FILES(request);
        if (!response?.isAuthorized) LOGOUT();

        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }

        var data = JSON.parse(response?.data!);
        setMediaDetails(data);

    };

    const SelectPropertyDetails = async (list: any) => {
        let inputObj = {
            UserID: list.UserID,
        };

        let request = JSON.stringify(inputObj);
        var response = await SELECT_PROPERTY_DETAILS(request);
        if (!response?.isAuthorized) LOGOUT();

        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }

        var data = JSON.parse(response?.data!);

        setPropertyDetails(data);

    };


    const SelectOwnerInfo = async (list: any) => {
        let inputObj = {
            UserID: list.UserID,
        };

        let request = JSON.stringify(inputObj);
        var response = await SELECT_OWNER_INFO(request);
        if (!response?.isAuthorized) LOGOUT();

        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }

        var data = JSON.parse(response?.data!);

        setOwnersDetails(data);
    };


    const SelectFinancialDetails = async (list: any) => {
        let inputObj = {
            UserID: list.UserID,
        };

        let request = JSON.stringify(inputObj);
        var response = await SELECT_FINANCIAL_DETAILS(request);
        if (!response?.isAuthorized) LOGOUT();

        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }

        var data = JSON.parse(response?.data!);
        setFinancialDetails(data);
    };

    const SelectInfraFacilitiesDetails = async (list: any) => {
        let inputObj = {
            UserID: list.UserID,
        };

        let request = JSON.stringify(inputObj);
        var response = await SELECT_INFRA_FACILITIES(request);
        if (!response?.isAuthorized) LOGOUT();

        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }

        var data = JSON.parse(response?.data!);
        setInfraFacilitiesDetails(data);

    };

    return {
        financialDetails,
        OwnersDetails,
        propertyDetails,
        mediaDetails,
        infraFacilitiesDetails
    };
};

export default UseCommercialPropertyInformation;
